module.exports = __webpack_public_path__ + "static/sole-layer-2-2a77da8b0f5566880241bc4cc1325c9c.png";